<ng-container *ngIf="item; else skeleton">
  <div (click)="onClickItem(); $event.preventDefault()">
    <div
      class="item-box onact96"
      [class.inactivated]="loading || maintenance || geoBlocked"
      [class.has-hover-move]="hasHover"
      [class.has-mask]="hasMask"
      (mouseenter)="hasMask && !loading && !maintenance && !geoBlocked && (hover = true)"
      (mouseleave)="hasMask && (hover = false)"
      [style.padding-top]="100 / ratio + '%'"
    >
      <!-- @if (hasFavorite && logined) {
        <div
          class="heart-icon"
          [class]="item.isFavorite ? 'icon-heart' : 'icon-heart-frame'"
          [class.active]="item.isFavorite"
          (click)="onLikeClick(item); $event.stopPropagation()"
        ></div>
      } -->
      <div class="item-con">
        <!-- loading的时候 -->
        <div class="loading skeleton-loading" *ngIf="loading"></div>
        <!-- 维护的时候 -->
        <div class="maintenance" *ngIf="maintenance && !geoBlocked">{{ 'game_main' | translate }}</div>
        <!-- GEO Blocked -->
        <div class="geo-blocked" *ngIf="geoBlocked">
          <img src="assets/svg/globe-filled.svg" alt="" class="geo-icon" />
          <div class="geo-text">
            <span class="geo-title">{{ 'game_geo_blocked' | translate }}</span>
            <span class="geo-sub">{{ 'game_geo_blocked_vpn' | translate }}</span>
          </div>
        </div>
        <!-- 图片 -->
        <app-lazy-image
          [lazy]="isProvider ? item['nightLogo'] : item['webLogo']"
          [defaultImg]="defaultImg()"
          [alt]="getAltText(item)"
        ></app-lazy-image>
        <!-- 信息遮罩，鼠标悬停延迟0.3秒后出现 -->
        <div class="mask-box" @delayShow *ngIf="hasMask && hover && !geoBlocked">
          <div class="play">Play</div>
          <!-- <div class="triangle"></div> -->
          <!-- <span class="item-title" *ngIf="item['gameName']">{{ item['gameName'] }}</span> -->
          <!-- <span class="item-desc" *ngIf="item['providerName']">{{ item['providerName'] }}</span> -->
        </div>
      </div>
    </div>
    <!-- @if (isGameUnit) {
    <div class="rtp-info">
      <span>RTP </span>
      <span class="rtp-color">
        {{ item.returnToPlayer === null ? '-' : (item.returnToPlayer ?? 100 - item.bankerAdvantage) + '%' }}
      </span>
    </div>
  } -->
    @if (isGameUnit) {
      <app-online-number [value]="item.isOnline || 0"></app-online-number>
    }
  </div>
</ng-container>
<ng-template #skeleton>
  <div class="item-box skeleton-loading" [style.padding-top]="100 / ratio + '%'"></div>
</ng-template>
